import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  LinearProgress,
} from "@mui/material";

const LoadingTable = () => {
  return (
    <TableContainer
      component={Paper}
      sx={{ mt: 2 }}
      style={{
        border: "1px solid rgba(255, 255, 255, 0.1)",
        boxShadow: "none",
      }}
    >
      <MuiTable>
        <TableHead>
          <TableRow></TableRow>
        </TableHead>
        <TableBody>
          <TableRow sx={{ padding: 0 }}>
            <TableCell sx={{ padding: 0 }}>
              <LinearProgress />
            </TableCell>
          </TableRow>
        </TableBody>
      </MuiTable>
    </TableContainer>
  );
};

export default LoadingTable;
